

// project import

// material-ui
import { Box, Button, Grid, Stack, Typography } from '@mui/material';

// assets
import construction from 'assets/images/maintenance/unauthorized.png';
import iomarketlogo from 'assets/images/icons/logo.svg';
import { FormattedMessage, useIntl } from 'react-intl';
import { memo, useMemo } from 'react';
import useConfig from 'hooks/useConfig';
import Localization from 'layout/Dashboard/Header/HeaderContent/Localization';
import { encrypt } from 'utils/commonFunctions';
import usePrivateKey from 'hooks/usePrivateKey';

// ==============================|| UNDER CONSTRUCTION - MAIN ||============================== //

const Unauthorized = memo(({ redirectUrl }: { redirectUrl: string; }) => {
  const intl = useIntl();
  const { i18n } = useConfig();
  const localization = useMemo(() => <Localization />, [i18n]);
  const { encryptionKey } = usePrivateKey();
  
  const handlLogin = () => {
    const encryptedData:any = encrypt(window.location.href,encryptionKey);
    window.location.replace(redirectUrl + '/auth/login/' + encodeURIComponent(encryptedData));
  }

  return (
    <>
      <Grid item container justifyContent="flex-end">
        <Grid item mr={5} mt={1}>
          {localization}
        </Grid>
      </Grid>
      <Grid container spacing={4} direction="column" alignItems="center" justifyContent="center" sx={{ minHeight: '100vh', py: 2 }}>
        <Grid item xs={12}>
          <Stack spacing={2}>
            <Typography align="center" variant="h3">
              {intl.formatMessage({ id: "unauthorized-text-1" })}
            </Typography>
            <Box sx={{ width: { xs: 320, sm: 410 } }}>
              <img src={construction} alt="mantis" style={{ width: '100%', height: 'auto' }} />
            </Box>
          </Stack>
        </Grid>
        <Grid item xs={8} sx={{ width: { xs: "100%", sm: "80%", md: "60%", lg: "30%" }, textAlign: "start" }}>
          <Stack spacing={2} justifyContent="center" alignItems="center">
            <Typography color="textSecondary" align="left" sx={{ width: '85%' }}>
              {intl.formatMessage({ id: "unauthorized-text-2" })}
              <strong>yourcompany.io-netgate.com.</strong>
            </Typography>
            <Typography color="textSecondary" align="left" sx={{ width: '85%' }}>
              {intl.formatMessage({ id: "unauthorized-text-3" })}
            </Typography>
            <Typography color="textSecondary" align="left" sx={{ width: '85%' }}>
              {intl.formatMessage({ id: "unauthorized-text-4" })}
            </Typography>
            <Typography color="textSecondary" align="left" sx={{ width: '85%' }}>
              {intl.formatMessage({ id: "unauthorized-text-5" })}
              <br></br>
              iomarket AG
            </Typography>
            {redirectUrl && <Button onClick={handlLogin} sx={{ textTransform: "none" }} variant="contained">
              <FormattedMessage id='back_to_login'></FormattedMessage>
            </Button>}
            <Box sx={{ width: { xs: 100 } }}>
              <img src={iomarketlogo} alt="iomarket" style={{ width: '100%', height: 'auto' }} />
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
})

export default Unauthorized;
